import { AwardsWall } from "@/components/AwardsWall";
import { Header } from "@/components/sections/Navbar";
import { HeroBanner } from "@/components/sections/Hero";
import { MostLovedSection } from "@/components/sections/FeaturedDeals";
import { SummerDestinations } from "@/components/sections/SummerDestinations";
import { Destinations } from "@/components/sections/Destinations";
import { FeatureCarousel } from "@/components/sections/FeatureCarousel";
import { YouTubeShorts } from "@/components/sections/YouTubeShorts";
import { Activities } from "@/components/sections/Services";
import { About } from "@/components/sections/About";
import { AssociationsMarquee } from "@/components/sections/AssociationsMarquee";
import { FAQ } from "@/components/sections/FAQ";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { FloatingWidgets } from "@/components/sections/FloatingWhatsApp";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-[var(--navy)]">
      <Header />
      <HeroBanner />
      <MostLovedSection />
      <SummerDestinations />
      <Destinations />
      <FeatureCarousel />
      <Activities />
      <About />
      <AssociationsMarquee />
      <YouTubeShorts />
      <FAQ />
      <Contact />
      <AwardsWall />
      <Footer />
      <FloatingWidgets />
    </main>
  );
}
